// language=GraphQL
export const ALL_TEAMS_QUERY = `query Query($withMembers: Boolean = false, $withMembersImage: Boolean = false) {
  teams: travelTeams {
    id
    name
    members @include(if: $withMembers) {
      id
      firstName
      lastName
      description
      image @include(if: $withMembersImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_TEAM_QUERY = `query Query($id: ID!, $withMembers: Boolean = false, $withMembersImage: Boolean = false) {
  team: travelTeam(id: $id) {
    id
    name
    members @include(if: $withMembers) {
      id
      firstName
      lastName
      description
      image @include(if: $withMembersImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const CREATE_TEAM_MUTATION = `
  mutation Mutation($input: CreateTravelTeamInput, $withMembers: Boolean = false, $withMembersImage: Boolean = false) {
    team: createTravelTeam(input: $input) {
      id
      name
      members @include(if: $withMembers) {
        id
        firstName
        lastName
        description
        image @include(if: $withMembersImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_TEAM_MUTATION = `
  mutation Mutation($input: UpdateTravelTeamInput, $withMembers: Boolean = false, $withMembersImage: Boolean = false) {
    team: updateTravelTeam(input: $input) {
      id
      name
      members @include(if: $withMembers) {
        id
        firstName
        lastName
        description
        image @include(if: $withMembersImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_TEAM_MUTATION = `
  mutation Mutation($input: DeleteTravelTeamInput) {
    deleteTravelTeam(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TEAM_MUTATION = `
  mutation Mutation($input: DeleteTravelTeamInput) {
    forceDeleteTravelTeam(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TEAM_MEMBERS_MUTATION = `
  mutation Mutation($input: addTravelTeamMembersInput) {
    addTravelTeamMembers(input: $input) {
      id
      memberIds
    }
  }`

// language=GraphQL
export const REMOVE_TEAM_MEMBERS_MUTATION = `
  mutation Mutation($input: removeTravelTeamMembersInput) {
    removeTravelTeamMembers(input: $input) {
      id
      memberIds
    }
  }`

// language=GraphQL
export const CREATE_TEAM_MEMBERS_MUTATION = `
  mutation Mutation($input: createTravelTeamMembersInput) {
    createTravelTeamMembers(input: $input) {
      id
      memberIds
    }
  }`

// language=GraphQL
export const DELETE_TEAM_MEMBERS_MUTATION = `
  mutation Mutation($input: deleteTravelTeamMembersInput) {
    deleteTravelTeamMembers(input: $input) {
      id
      memberIds
    }
  }`

// language=GraphQL
export const UPDATE_TEAM_MEMBERS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelTeamMembersOrderInput) {
    updateTravelTeamMembersOrder(input: $input) {
      id
      memberIds
    }
  }`

// language=GraphQL
export const TEAMS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelTeamDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
  }
}`
